<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :title="title"
    size="large"
  >
    <template #header>
      <DropdownTaskStatusSquare
        :options="c_translated_option"
        :current="workTask?.status"
        :icon="c_actual_status_icon"
        label="label"
        @select="mChangeStatus"
      />
      <BaseButton
        :icon="editionMode ? 'times' : 'pen'"
        :title="editionMode ? $t('button.cancel') : $t('button.edit')"
        color="warning"
        size="small"
        @click="changeEditionMode"
      />
    </template>
    <template #body>
      <div class="flex w-full flex-col gap-3">
        <div class="overflow-x-auto">
          <dl class="grid-form pt-1">
            <div>
              <BaseShowEditInput
                :label="$t('global.task')"
                v-model="workTask.name"
                :editionMode="editionMode"
              />
            </div>

            <div>
              <BaseShowEditFilteredUsersComponent
                :label="$t('global.responsible')"
                v-model="workTask.responsable_id"
                :editionMode="editionMode"
                name="responsable"
                :metadata="metadata"
              />
              <!--                <BaseShowEditSelectSimple-->
              <!--                  :label="$t('global.responsible')"-->
              <!--                  v-model='workTask.responsable_id'-->
              <!--                  :editionMode='editionMode'-->
              <!--                  name='responsable'-->
              <!--                  :options='metadata.users'-->

              <!--                />-->
            </div>

            <div class="col-span-full">
              <BaseShowEditTextArea
                :label="$t('global.informations')"
                :placeholder="$t('global.informations')"
                v-model="workTask.description"
                :editionMode="editionMode"
              />
            </div>

            <!--#region registre -->
            <div
              v-if="
                c_status_change_activities_ordered_desc &&
                c_status_change_activities_ordered_desc.length
              "
              class="col-span-full"
            >
              <dt class="text-sm font-medium text-gray-500 capitalize-first">
                {{ $t('global.activities') }}
              </dt>
              <div
                v-for="activity in c_status_change_activities_ordered_desc"
                class="px-2 py-1"
              >
                <TaskStatusChangeActivityItem
                  :activity="activity"
                  :metadata="metadata"
                  :editionMode="editionMode"
                  :task="workTask"
                />
                <hr class="mt-4 mb-2" />
              </div>
            </div>
            <!--#endregion -->
            <div></div>
          </dl>
        </div>
      </div>
    </template>
    <template #footer>
      <BaseButton
        v-if="editionMode"
        :icon="submitButtonIcon"
        color="primary"
        :title="submitButtonTitle"
        @click="submitForm"
      />
      <BaseButton :title="$t('button.close')" color="dark" @click="close" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'

import TaskStatusChangeActivityItem from './TaskStatusChangeActivityItem'

import { mapFields } from 'vuex-map-fields'
import BaseShowEditFilteredUsersComponent from '@c/GlobalFormComponents/BaseShowEditFilterdUsersComponent.vue'

export default {
  name: 'WorkTaskFormDialog',
  emits: ['close', 'backdropClicked'],
  components: {
    BaseCenteredModal,
    BaseShowEditFilteredUsersComponent,
    // DropdownTaskStatusSquare,
    TaskStatusChangeActivityItem
  },
  props: {
    isModalVisible: {
      type: Boolean,
      required: true
    },
    taskId: {
      type: [String, Number]
    },
    workId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      modalVisible: this.isModalVisible,
      editionMode: false
    }
  },
  computed: {
    ...mapGetters({
      errors: 'auth/getErrors',
      metadata: 'work/getWorkMetadata'
    }),
    ...mapFields('work', { workTask: 'selectedWorkTask' }),
    localIsModalOpen: {
      get() {
        return this.isModalVisible
      },
      set(value) {
        if (!value) this.close()
      }
    },
    c_translated_option() {
      return this.metadata.tasks.status.reduce((array, item) => {
        array.push({
          ...item,
          label: this.$t('enums.task.status.' + item.id)
        })
        return array
      }, [])
    },
    c_actual_status_color() {
      return this.metadata.tasks.status.find(
        (status) => status.id === this.workTask.status
      )?.bg_color
    },
    c_actual_status_icon() {
      return this.metadata.tasks.status.find(
        (status) => status.id === this.workTask.status
      )?.icon
    },
    c_actual_status_label() {
      return this.metadata.tasks.status.find(
        (status) => status.id === this.workTask.status
      )?.label
    },
    c_status_change_activities_ordered_desc() {
      return this.workTask.status_change_activities
    },
    title() {
      return this.workTask?.id
        ? this.workTask?.name
        : this.$t('global.new_task')
    },
    submitButtonTitle() {
      return this.workTask.id
        ? this.$t('button.edit_new_f', { var: this.$t('global.task') })
        : this.$t('button.add_new_f', { var: this.$t('global.task') })
    },
    submitButtonIcon() {
      return this.workTask.id ? 'edit' : 'plus'
    },
    titleUpdateOrCancel() {
      return this.editionMode
        ? this.$t('button.cancel')
        : this.$t('button.update')
    }
  },
  methods: {
    ...mapActions({
      updateWorkTaskStatus: 'work/updateWorkTaskStatus',
      storeWorkTask: 'work/storeWorkTask',
      updateWorkTask: 'work/updateWorkTask',
      fetchWorkById: 'work/fetchWorkByID'
    }),
    mChangeStatus(newStatus) {
      if (newStatus.id !== this.workTask.id) {
        if (!this.workTask.form_on_start && !this.workTask.form_on_end) {
          if (newStatus.id === 4) {
            this.$emit('openModal', {
              modal: 'TaskFormDialog',
              task: this.workTask,
              form: 'reason',
              nextStatus: newStatus.id
            })
            return
          }
          this.updateWorkTaskStatus({
            id: this.workTask.id,
            new_status: newStatus.id
          }).then(() => {
            this.$h.toastSuccess(
              this.$t('toasts.updated_f', {
                var: this.$t('attributes.task')
              })
            )
          })
          return
        }

        if (newStatus.id === 2) {
          if (this.workTask.form_on_start) {
            this.$emit('openModal', {
              modal: 'TaskFormDialog',
              task: this.workTask,
              form: 'starting_form',
              nextStatus: newStatus.id
            })
          } else {
            this.updateWorkTaskStatus({
              id: this.workTask.id,
              new_status: newStatus.id
            }).then(() => {
              this.$h.toastSuccess(
                this.$t('toasts.updated_f', {
                  var: this.$t('attributes.task')
                })
              )
            })
          }
          return
        }

        //si le nouveau status est 4 =>"AWAITING" ou 3 => "COMPLETED" et que la tâche a un starting_form on affiche une popup (text = veuillez d'abord démarrer la tâche)
        if (
          (newStatus.id === 3 || newStatus.id === 4) &&
          this.workTask.form_on_start &&
          this.workTask.starting_form[0].value === null
        ) {
          this.$h.toastWarning(this.$t('toasts.start_task_first'))
          return
        }

        if (
          newStatus.id === 4 &&
          (!this.workTask.form_on_start ||
            (this.workTask.form_on_start &&
              this.workTask.starting_form[0].value !== null))
        ) {
          this.$emit('openModal', {
            modal: 'TaskFormDialog',
            task: this.workTask,
            form: 'reason',
            nextStatus: newStatus.id
          })
          return
        }

        if (newStatus.id === 3 && !this.workTask.form_on_end) {
          this.updateWorkTaskStatus({
            id: this.workTask.id,
            new_status: newStatus.id
          }).then(() => {
            this.$h.toastSuccess(
              this.$t('toasts.updated_f', {
                var: this.$t('attributes.task')
              })
            )
          })
          return
        }

        //si le nouveau status est 3 => "COMPLETED", que le status actuel est 4 ou 2 (ou que la tâche n'a pas de starting_form) et que la tache à un ending_form on affiche une popup avec le ending_form
        this.$emit('openModal', {
          modal: 'TaskFormDialog',
          task: this.workTask,
          form: 'ending_form',
          nextStatus: newStatus.id
        })
      }
    },
    getInputValue({ attribute, value }) {
      this.event[attribute] = value
    },
    afterWorkSelected(work) {
      this.event.work_id = work.id
    },
    close() {
      this.$emit('close')
      this.editionMode = false
    },
    submitNewTask() {
      return this.storeWorkTask({
        task: this.workTask
      }).then(() => {
        this.close()
        this.editionMode = false
      })
    },
    submitUpdateTask() {
      return this.updateWorkTask({
        id: this.workTask.id,
        task: this.workTask
      }).then(() => {
        this.editionMode = false
      })
    },
    submitForm() {
      if (this.workTask.id) {
        this.submitUpdateTask()
      } else {
        this.submitNewTask()
      }
    },
    changeEditionMode() {
      if (this.editionMode) {
        this.fetchWorkById(this.workId)
      }
      this.editionMode = !this.editionMode
    }
  }
}
</script>
